import { LearningPortfolioNote } from './learning-portfolio-note';
import { LearningPortfolioNoteListDto } from './learning-portfolio.dto';

export class LearningPortfolioNoteList {
    readonly items: LearningPortfolioNote[];
    readonly total: number;

    constructor(dto: LearningPortfolioNoteListDto) {
        this.items = dto.items.map((item) => new LearningPortfolioNote(item));
        this.total = dto.total;
    }
}
